// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__F0Gnl","modalFooterButton":"ModalNotes_modalFooterButton__3EoIz"};